import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import zhRoutes from './routes.zh'
import enRoutes from './routes.en'

Vue.use(VueRouter)

const scrollableElementId = 'main-content'

// 动态合并中英文路由
const routes = [...zhRoutes, ...enRoutes]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    const tag = store.state.viewTags.viewTags.find(
      (item) => item.path === to.path,
    )
    return { y: tag?.scrollTop || 0 }
  },
})

router.beforeEach((to, from, next) => {
  const scrollTop = document.getElementById(scrollableElementId)
  if (scrollTop) {
    store.commit('updateViewTags', {
      path: from.path,
      scrollTop:
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0,
    })
  }

  // 登录和注册页面放行（中英文）
  const whiteList = ['/login', '/entry', '/login_EN', '/entry_EN']
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  const token = sessionStorage[process.env.VUE_APP_TOKEN]
  if (!token) {
    // 中英文自动跳转登录
    next(to.path.startsWith('/en') ? '/login_EN' : '/login')
    return
  }

  const userInfo = localStorage.getItem('userInfo')
  const resources = JSON.parse(userInfo)?.resources
  if (
    !to.meta?.access ||
    resources?.includes(to.meta.access) ||
    resources?.includes('ROLE_ADMIN')
  ) {
    next()
  } else {
    next(to.path.startsWith('/en') ? '/en/home' : '/home')
  }
})

export default router
